import { normalizeCategoryCode, type CategoryCode, type VerificationStatus } from "@oshimap/domain";
import { eventStatus, formatDistance } from "@oshimap/utils";
import type { MapMarkerData } from "./types";

/** 지도 코드가 아니라 화면이 쓰는 형태. Legacy `marker-view-model.ts` 승격. */
export interface MarkerViewModel {
  key: string;
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  category: CategoryCode;
  verification: VerificationStatus;
  isFavorited: boolean;
  hasVisited: boolean;
  activeEventCount: number;
  distanceLabel: string | null;
  isEvent: boolean;
  /** 종료·취소된 이벤트는 지도에서 흐리게 (I-EV-04) */
  dimmed: boolean;
}

export function toMarkerViewModel(
  m: MapMarkerData,
  opts: { visitedKeys?: ReadonlySet<string>; now?: Date } = {},
): MarkerViewModel {
  const isEvent = (m.targetType ?? (m.eventId ? "EVENT" : "PLACE")) === "EVENT";
  const key = `${isEvent ? "EVENT" : "PLACE"}:${m.id}`;
  const status = isEvent ? eventStatus({ startsAt: m.startsAt, endsAt: m.endsAt, status: m.status }, opts.now) : null;
  return {
    key,
    id: m.id,
    name: m.name,
    latitude: m.latitude,
    longitude: m.longitude,
    category: normalizeCategoryCode(m.categoryCode),
    verification: (m.verificationStatus as VerificationStatus) ?? "UNVERIFIED",
    isFavorited: m.isFavorited,
    hasVisited: m.hasVisited ?? opts.visitedKeys?.has(key) ?? false,
    activeEventCount: m.activeEventCount,
    distanceLabel: typeof m.distanceMeters === "number" ? formatDistance(m.distanceMeters) : null,
    isEvent,
    dimmed: status === "ENDED" || status === "CANCELLED" || m.placeStatus === "CLOSED",
  };
}
